import { REQUEST_FREEWRITE_EXPORT } from '../EditorOverlayActions/ActionTypes';

export const DEFAULT_STATE = false;

const continueAndExport = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case REQUEST_FREEWRITE_EXPORT:
      return true;
    default:
      return state;
  }
};

export default continueAndExport;



// WEBPACK FOOTER //
// ./src-react/EditorOverlay/EditorOverlayReducer/continueAndExport.jsx